import { convexToJson, jsonToConvex } from "@convex-dev/common";
export class MutationManager {
    constructor() {
        this.inflightMutations = new Map();
    }
    request(udfPath, args, mutationId) {
        const message = {
            type: "Mutation",
            mutationId,
            udfPath,
            args: convexToJson(args),
        };
        const result = new Promise((resolve, reject) => {
            this.inflightMutations.set(mutationId, {
                message,
                onResult: resolve,
                onFailure: reject,
                status: { status: "Requested" },
            });
        });
        return { message, result };
    }
    onResponse(response) {
        const mutationInfo = this.inflightMutations.get(response.mutationId);
        if (mutationInfo === undefined) {
            throw new Error(`Unable to find mutation info for id ${response.mutationId}`);
        }
        if (mutationInfo.status.status !== "Requested") {
            throw new Error(`Unexpected mutation status for id ${response.mutationId}: ${mutationInfo.status}`);
        }
        const udfPath = mutationInfo.message.udfPath;
        for (const line of response.logLines) {
            console.log(`%c[CONVEX M(${udfPath})] ${line}`, "color:green");
        }
        if (response.success) {
            mutationInfo.status = {
                status: "Committed",
                ts: response.ts,
            };
            mutationInfo.onResult(jsonToConvex(response.result));
        }
        else {
            this.inflightMutations.delete(response.mutationId);
            const failureMessage = `[CONVEX M(${udfPath})] ${response.result}`;
            console.error(failureMessage);
            mutationInfo.onFailure(new Error(failureMessage));
        }
    }
    removeCompletedMutations(ts) {
        const completeMutations = new Set();
        for (const [mutationId, mutationInfo] of this.inflightMutations.entries()) {
            const status = mutationInfo.status;
            if (status.status == "Committed" && status.ts <= ts) {
                completeMutations.add(mutationId);
                this.inflightMutations.delete(mutationId);
            }
        }
        return completeMutations;
    }
    restart() {
        // TODO(CX-657): Once our mutations are idempotent, reissue mutations on reconnect
        // For now though we drop them and fail the promises because we don't want
        // to risk double-executing them.
        // const allMessages = [];
        // for (const value of this.inflightMutations.values()) {
        //   allMessages.push(value.message);
        // }
        // return allMessages;
        for (const value of this.inflightMutations.values()) {
            value.onFailure("Unable to dispatch mutation because there was no active WebSocket connection");
        }
        this.inflightMutations = new Map();
        return [];
    }
}
//# sourceMappingURL=mutation_manager.js.map